import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../lib/api';
import { VenteForm } from '../components/ventes/VenteForm';

export function VenteNouveauPage(): JSX.Element {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: api.ventes.create,
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: ['ventes'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      navigate(`/ventes/${String(data.vente.id)}`);
    },
    onError: (err: unknown) => {
      if (err instanceof ApiError) {
        setError(
          `${err.message}${err.details !== undefined ? ` — ${JSON.stringify(err.details)}` : ''}`,
        );
      } else {
        setError('Erreur création vente.');
      }
    },
  });

  return (
    <div className="max-w-5xl">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Nouvelle vente</h1>
        <p className="text-xs text-slate-500 mt-1">
          Saisir les informations de la facture. Les calculs sont effectués par le serveur.
        </p>
      </header>

      {error !== null && (
        <div className="mb-4 text-xs text-red-300 bg-red-900/20 border border-red-900/50 rounded-md px-3 py-2">
          {error}
        </div>
      )}

      <VenteForm
        submitting={mutation.isPending}
        onSubmit={(payload): void => mutation.mutate(payload)}
        onCancel={(): void => navigate('/ventes')}
      />
    </div>
  );
}
